module.exports = __webpack_public_path__ + "static/media/wij-water-interreg-vn-eu-horizontal.1a1daaa5.png";